import {
  GET_BANNERS,
  GET_BANNERS_SUCCESS,
  GET_BANNERS_FAIL,
  ADD_NEW_BANNER,
  ADD_NEW_BANNER_SUCCESS,
  ADD_NEW_BANNER_FAIL,
  GET_BANNER_DETAILS,
  GET_BANNER_DETAILS_SUCCESS,
  GET_BANNER_DETAILS_FAIL,
  UPDATE_BANNER,
  UPDATE_BANNER_SUCCESS,
  UPDATE_BANNER_FAIL,
  DELETE_BANNER,
  DELETE_BANNER_SUCCESS,
  DELETE_BANNER_FAIL,
  MODIFY_BANNER_FLAG,
  RESET_BANNER_FLAG,
} from "./actionTypes";

export const getBanners = data => ({
  type: GET_BANNERS,
  payload: data,
});

export const getBannersSuccess = data => ({
  type: GET_BANNERS_SUCCESS,
  payload: data,
});

export const getBannersFail = error => ({
  type: GET_BANNERS_FAIL,
  payload: error,
});

export const addNewBanner = banner => ({
  type: ADD_NEW_BANNER,
  payload: banner,
});

export const addNewBannerSuccess = banner => ({
  type: ADD_NEW_BANNER_SUCCESS,
  payload: banner,
});

export const addNewBannerFail = error => ({
  type: ADD_NEW_BANNER_FAIL,
  payload: error,
});

export const updateBanner = banner => ({
  type: UPDATE_BANNER,
  payload: banner,
});

export const updateBannerSuccess = banner => ({
  type: UPDATE_BANNER_SUCCESS,
  payload: banner,
});

export const updateBannerFail = error => ({
  type: UPDATE_BANNER_FAIL,
  payload: error,
});

export const getBannerDetails = banner => ({
  type: GET_BANNER_DETAILS,
  payload: banner,
});

export const getBannerDetailsSuccess = role => ({
  type: GET_BANNER_DETAILS_SUCCESS,
  payload: role,
});

export const getBannerDetailsFail = error => ({
  type: GET_BANNER_DETAILS_FAIL,
  payload: error,
});

export const delBanner = data => ({
  type: DELETE_BANNER,
  payload: data,
});

export const deleteBannerSuccess = data => ({
  type: DELETE_BANNER_SUCCESS,
  payload: data,
});

export const deleteBannerFail = data => ({
  type: DELETE_BANNER_FAIL,
  payload: data,
});
export const modifyBannerFlag = () => {
  return {
    type: MODIFY_BANNER_FLAG,
  }
}

export const resetBannerFlag = () => {
  return {
    type: RESET_BANNER_FLAG,
  }
}
